import { render, staticRenderFns } from "./Embryos.vue?vue&type=template&id=d50f8672&"
import script from "./Embryos.vue?vue&type=script&lang=js&"
export * from "./Embryos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports